export default __webpack_public_path__ + "c71999ecd5ef2fbd1fb7b0cfd4871038.svg";